import { useTranslation } from 'react-i18next'
import localizeDuration from '../helpers/localizeDuration'
import useCountdown from '../hooks/useCountdown'

export default function PlanCardCountdown({
  countdownUntil,
}: {
  countdownUntil: number
}) {
  const duration = useCountdown(countdownUntil)
  const { t } = useTranslation()

  if (countdownUntil < Date.now()) return null

  return (
    <div className="mt-3 rounded-lg bg-[#D65353] px-4 py-1.5 text-center sm:mt-4 sm:rounded-xl sm:px-5 sm:py-2">
      <p className="text-xs text-white sm:text-sm">
        {t('pages.checkout.plans.offerEnds', {
          countdown: localizeDuration({ duration }),
        })}
      </p>
    </div>
  )
}
